export default __webpack_public_path__ + "static/media/double-arrow-right.c55d5e9e.svg";